import { LogLevel } from "@azure/msal-browser";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Config object to be passed to Msal on creation
export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID || "f8bdcc5f-2d25-4f83-affd-f54ee4fd1686",
        authority: process.env.REACT_APP_MSAL_AUTHORITY || "https://login.microsoftonline.com/0f9e35db-544f-4f60-bdcc-5ea416e6dc70/",
        redirectUri: "/",
        postLogoutRedirectUri: "/",
        scope: [process.env.REACT_APP_MSAL_API_SCOPE || "https://api-psdatadev.un.org/api.call"]
    },
    cache: {
        // storeAuthStateInCookie: isIE || isEdge || isFirefox
        storeAuthStateInCookie: false,
        cacheLocation: 'localStorage'
    },  
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {	
                    return;	
                }
                switch (level) {	
                    case LogLevel.Error:	
                        // console.error(message);	
                        return;	
                    case LogLevel.Info:	
                        // console.info(message);	
                        return;	
                    case LogLevel.Verbose:	
                        // console.debug(message);	
                        return;	
                    case LogLevel.Warning:	
                        // console.warn(message);	
                        return;	
                    default:
                        return;
                }
            }
        }
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: [process.env.REACT_APP_MSAL_API_SCOPE]
};


